var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-show',{attrs:{"item":_vm.item}},[_c('va-field',{attrs:{"source":"id"}}),_c('va-field',{attrs:{"source":"scopes"},scopedSlots:_vm._u([{key:"default",fn:function({ value }){return [_c('base-Scopes-selector',{attrs:{"scopes":value}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }